import { ISession, SessionStage } from '../interfaces/session.interface';

export const getSessionBySessionKey = (sessions: ISession[], sessionKey: string) => {
    return sessions.find((session) => session.sessionKey === sessionKey);
};

export const getEmptySession = (sessions: ISession[]) => {
    return sessions.find((session) => session.stage === SessionStage.PLAN) || null;
};
